<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<!-- Page Header -->
<div class="page-header">
  <h1 class="page-title">Files</h1>
  <div class="header-actions">

    @if (canUpload) {
    <button class="btn-outline" type="button" (click)="showAddFileFolderDialog = true" [disabled]="isProjectInactive">
      <i class="ri-folder-add-line"></i>
      <span>New Folder</span>
    </button>
    <button class="btn-primary" type="button" (click)="showAddFileDialog = true" [disabled]="isProjectInactive">
      <i class="ri-add-line"></i>
      <span>New File</span>
    </button>
    }
    @if (canDelete) {
    <p-menu #menu [model]="actionItems" [popup]="true" appendTo="body" />
    <button class="btn-icon-only" type="button" (click)="menu.toggle($event)" [disabled]="isProjectInactive">
      <i class="ri-more-2-line"></i>
    </button>
    }
  </div>
</div>

<!-- Files Body -->
<div class="files-body">
  @for (folder of filteredFolderList; track folder.fileFolderId) {
  <div class="folder-section">

    <!-- Folder Header Row -->
    <div class="folder-header-row" (click)="toggleFolderCollapse(folder.fileFolderId)">
      <div class="folder-header-left">
        @if (canDelete) {
        <label class="custom-checkbox" (click)="$event.stopPropagation()">
          <input type="checkbox" [checked]="isFolderFullySelected(folder)"
            [indeterminate]="isFolderPartiallySelected(folder)" (change)="toggleFolderSelection(folder)" />
          <span class="custom-checkbox-box">
            <i class="ri-check-line custom-checkbox-check"></i>
            <i class="ri-subtract-line custom-checkbox-indeterminate"></i>
          </span>
        </label>
        }
        <button class="collapse-btn" type="button"
          (click)="$event.stopPropagation(); toggleFolderCollapse(folder.fileFolderId)">
          <i [class]="isFolderCollapsed(folder.fileFolderId) ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'"></i>
        </button>
        <span class="folder-name">{{ folder.folderName }}</span>
        <span class="folder-file-count">{{ folder.projectFileList?.length || 0 }} {{ (folder.projectFileList?.length || 0) === 1 ? 'file' : 'files' }}</span>
      </div>
      <div class="folder-header-right">
        <span class="file-column-header">Updated By</span>
        <span class="file-column-header">Last Updated</span>
        <div class="folder-header-actions">
          @if (folder.fileFolderId > 0) {
          <button class="btn-add-file" type="button" (click)="$event.stopPropagation(); onDownloadFolder(folder)">
            <i class="ri-download-line"></i>
            <span>Download</span>
          </button>
          }
          @if (canUpload) {
          <button class="btn-add-file" type="button" (click)="$event.stopPropagation(); onAddFileToFolder(folder)"
            [disabled]="isProjectInactive">
            <i class="ri-add-line"></i>
            <span>Add</span>
          </button>
          }
        </div>
      </div>
    </div>

    <!-- File List -->
    @if (!isFolderCollapsed(folder.fileFolderId)) {
    <div class="folder-content">
      @if (!folder.projectFileList || folder.projectFileList.length === 0) {
      <div class="empty-folder">
        <i class="ri-inbox-line"></i>
        <span>No files in this folder</span>
      </div>
      } @else {
      <div class="file-list">
        @for (file of folder.projectFileList; track file.fileId) {
        <div class="file-row">
          @if (canDelete) {
          <label class="custom-checkbox" (click)="$event.stopPropagation()">
            <input type="checkbox" [checked]="isFileSelected(file.fileId)"
              (change)="toggleFileSelection(file.fileId)" />
            <span class="custom-checkbox-box">
              <i class="ri-check-line custom-checkbox-check"></i>
            </span>
          </label>
          }
          <div class="file-info" (click)="onFileClick(file)">
            <div class="file-icon-badge" [style.background]="getFileIconBg(file)">
              <i [class]="getFileIcon(file)" [style.color]="getFileIconColor(file)"></i>
            </div>
            <span class="file-name">{{ file.fileName || file.fileFullName }}</span>
          </div>
          <span class="file-updated-by">{{ file.updatedByName || '-' }}</span>
          <span class="file-last-updated">{{ file.lastUpdated ? (file.lastUpdated | date:'MMM d, yyyy') : '-' }}</span>
          <div class="file-actions">
            <button class="file-action-btn file-action-edit" type="button" title="Edit file name"
              (click)="$event.stopPropagation(); onEditFileName(file)" [disabled]="isProjectInactive">
              <i class="ri-pencil-line"></i>
            </button>
            <button class="file-action-btn file-action-download" type="button" title="Download"
              (click)="$event.stopPropagation(); onDownloadFile(file)">
              <i class="ri-download-line"></i>
            </button>
            @if (canDelete) {
            <button class="file-action-btn file-action-delete" type="button" title="Delete"
              (click)="$event.stopPropagation(); onDeleteFile(file, folder)" [disabled]="isProjectInactive">
              <i class="ri-delete-bin-line"></i>
            </button>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }

  </div>
  }

  @if (folderList.length === 0) {
  <div class="empty-state">
    <i class="ri-folder-open-line"></i>
    <p class="empty-title">No folders available</p>
    <p class="empty-subtitle">Create a folder to start adding files</p>
  </div>
  }
</div>

<!-- Create Folder Dialog -->
<p-dialog
  header="Create Folder"
  [modal]="true"
  [(visible)]="showAddFileFolderDialog"
  [style]="{ width: '25rem' }"
  [contentStyle]="{ overflow: 'hidden', padding: '0' }"
  styleClass="kansei-dialog files-folder-dialog">
  <div class="folder-dialog">
    <div class="folder-dialog-content">
      <div class="grid">
        <div class="col-12">
          <label for="folderName" class="modal-label">Folder Name</label>
          <input type="text" pInputText id="folderName" [(ngModel)]="projectFileFolderModel.folderName" class="w-full" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showAddFileFolderDialog = false">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="addPlanFolder()" [disabled]="!canUpload || isProjectInactive">Save</button>
    </div>
  </div>
</p-dialog>

<!-- Edit File Name Dialog -->
<p-dialog header="Edit File Name" [modal]="true" [(visible)]="showEditFileNameDialog" [style]="{ width: '25rem' }">
  <div class="grid">
    <div class="col-12">
      <label for="editFileName" class="block text-900 font-medium mb-2">File Name</label>
      <input type="text" pInputText id="editFileName" [(ngModel)]="editFileName" class="w-full" />
    </div>
  </div>
  <div class="flex justify-end gap-2 mt-4">
    <p-button label="Cancel" severity="secondary" (click)="showEditFileNameDialog = false" />
    <p-button label="Save" (click)="saveEditFileName()" [disabled]="isProjectInactive" />
  </div>
</p-dialog>

<!-- Upload Files Dialog -->
<p-dialog
  header="Upload Files"
  [modal]="true"
  [(visible)]="showAddFileDialog"
  [closable]="!isUploading"
  [closeOnEscape]="!isUploading"
  [style]="{ width: '50rem' }"
  [contentStyle]="{ overflow: 'hidden', padding: '0' }"
  styleClass="kansei-dialog files-upload-dialog">
  <div class="upload-file-dialog">
    <div class="upload-file-content">
      <div class="upload-size-note">
        <i class="ri-information-line"></i>
        <span>Each file must be 20 MB or smaller.</span>
      </div>
      <div class="fileupload-modal-wrapper">
        <p-fileupload class="fileupload-full" name="demo[]" customUpload="true" showUploadButton="false"
          [multiple]="true" [maxFileSize]="maxProjectFileSizeBytes" mode="advanced"
          (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove($event)" (onClear)="onFileClear()"
          (onValidationFail)="onFileValidationFail($event)"
          [disabled]="!canUpload || isProjectInactive || isUploading">
          <ng-template #content let-files let-removeFileCallback="removeFileCallback">
            @if (isUploading) {
            <div class="upload-progress-summary">
              <span>Uploading {{ uploadCurrentFileNumber }}/{{ uploadTotalFiles }}</span>
              <span>{{ uploadCompletedFiles }} uploaded</span>
              @if (uploadFailedFiles > 0) {
              <span>{{ uploadFailedFiles }} failed</span>
              }
            </div>
            }
            @if (selectedFiles.length) {
            <div class="upload-preview-list">
              @for (file of selectedFiles; track file?.name + '-' + file?.size + '-' + file?.lastModified; let i = $index) {
              <div class="upload-preview-row">
                <div class="upload-preview-file">
                  <div class="upload-file-icon-badge" [style.background]="getUploadFileIconBg(file)">
                    <i [class]="getUploadFileIcon(file)" [style.color]="getUploadFileIconColor(file)"></i>
                  </div>
                  <div class="upload-preview-meta">
                    <div class="upload-preview-name">{{ file.name }}</div>
                    <div class="upload-preview-size">{{ formatFileSize(file.size || 0) }}</div>
                  </div>
                </div>
                <span class="upload-preview-status" [ngClass]="'status-' + getUploadStatus(file)">
                  {{ getUploadStatusLabel(file) }}
                </span>
                <button
                  type="button"
                  class="upload-preview-remove"
                  aria-label="Remove file"
                  [disabled]="isUploading"
                  (click)="removeSelectedFile($event, i, removeFileCallback)">
                  <i class="ri-close-line"></i>
                </button>
              </div>
              }
            </div>
            } @else {
            <div class="upload-preview-empty">Drag and drop files to here to upload.</div>
            }
          </ng-template>
          <ng-template #empty>
            <div>Drag and drop files to here to upload.</div>
          </ng-template>
        </p-fileupload>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="cancelUploadDialog()" [disabled]="isUploading">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="addProjectFile()" [disabled]="!canUpload || isProjectInactive || isUploading">
        {{ uploadActionLabel }}
      </button>
    </div>
  </div>
</p-dialog>
